import dropdown from './dropdown.vue'

dropdown.install = function(Vue) {
  Vue.component(dropdown.name, dropdown)
}

export default dropdown
